import React, { useState, useRef, useEffect } from 'react';
import { FaTelegramPlane } from 'react-icons/fa';

const WhatsAppButton = () => {
  const [showPopup, setShowPopup] = useState(false);
  const popupRef = useRef(null);

  const togglePopup = (e) => {
    e.preventDefault();
    setShowPopup((prev) => !prev);
  };

  // Detect click outside popup
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    };

    if (showPopup) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showPopup]);

  return (
    <>
      <style>{`
        .whatsapp-float {
          position: fixed;
          bottom: 20px;
          right: 20px;
          z-index: 9999;
          background-color: rgba(37, 211, 102, 0.2);
          border-radius: 50%;
          padding: 10px;
          transition: transform 0.3s ease-in-out;
          box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.5);
          animation: pulse 2s infinite;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        @keyframes pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.5);
          }
          70% {
            box-shadow: 0 0 0 15px rgba(37, 211, 102, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
          }
        }

        .whatsapp-icon {
          width: 60px;
          height: 60px;
          animation: ${showPopup ? 'none' : 'tilt 3s infinite'};
        }

        @keyframes tilt {
          0%, 33% {
            transform: rotate(0deg);
          }
          38% {
            transform: rotate(-15deg);
          }
          43% {
            transform: rotate(15deg);
          }
          48% {
            transform: rotate(-15deg);
          }
          53% {
            transform: rotate(15deg);
          }
          58% {
            transform: rotate(-15deg);
          }
          63% {
            transform: rotate(15deg);
          }
          68% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(0deg);
          }
        }

        .notification-dot {
          position: absolute;
          top: 10px;
          right: 10px;
          width: 12px;
          height: 12px;
          background-color: red;
          border-radius: 50%;
          z-index: 10000;
          display: ${showPopup ? 'none' : 'block'};
        }

        .close-icon {
          width: 60px;
          height: 60px;
          font-size: 35px;
          color: white;
          background: #25D366;
          display: flex;
          justify-content: center;
          align-items: center;
          border: none;
          line-height: 1;
        }

        .whatsapp-popup-container {
          position: fixed;
          bottom: 100px;
          right: 20px;
          width: 30%;
          height: 65%;
          z-index: 10000;
        }

        @media (max-width: 768px) {
          .whatsapp-popup-container {
            width: 90% !important;
            height: 50% !important;
            left: 5%;
            right: 5%;
          }
        }

        .whatsapp-message-box {
          position: relative;
          margin-bottom: 8px;
        }

        .whatsapp-message-box::after {
          content: '';
          position: absolute;
          top: 10px;
          left: -8px;
          width: 0;
          height: 0;
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
          border-right: 8px solid white;
        }
      `}</style>

      
      <div ref={popupRef} className={`whatsapp-popup-container ${showPopup ? 'd-block' : 'd-none'} shadow`}>
        <div className="card h-100">
          <div className="card-header bg-whatsapp text-white d-flex justify-content-between gap-2 p-0">
            <div className='d-flex align-items-center gap-3 p-3'>
              <img src="https://smartarget-sp.ams3.cdn.digitaloceanspaces.com/assets/support5.webp" alt="Avatar" className="rounded-circle" width="50" height="50" />
              <div className="d-flex flex-column">
                <span className="fw-bold">BHEPL</span>
                <span className="small">Chat with us</span>
              </div>
            </div>
            <a onClick={togglePopup} style={{ cursor: 'pointer' }}>
              <i className="bi bi-x fs-28 px-2" style={{ height: "28px", width: "28" }}></i>
            </a>
          </div>
          <div className="card-body p-3 d-flex flex-column position-relative">
            <div
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{
                background: 'url(/whatsapp-bg.png) no-repeat center center',
                backgroundSize: 'cover',
                opacity: 0.9,
              }}
            ></div>

            <div className="bg-white rounded-3 p-3 whatsapp-message-box shadow-sm fs-14">
              👋 Hey! Please submit your query, Our team will get back to you soon.
            </div>
          </div>
          <div className="card-footer p-2">
            <a
              href="https://wa.me/919100900144"
              target="_blank"
              rel="noopener noreferrer"
              className="btn bg-whatsapp w-100 rounded-0 fw-bold py-2 text-white fs-14 d-flex align-items-center justify-content-center rounded-1"
            >
              <FaTelegramPlane className='fs-22 me-2' />
              START CHAT
            </a>
          </div>
        </div>
      </div>

      <a
        href="#"
        className="whatsapp-float text-decoration-none"
        onClick={togglePopup}
      >
        <span className="notification-dot"></span>
        {showPopup ? (
          <i className="bi bi-x close-icon rounded-circle border-0 bg-whatsapp"></i>
        ) : (
          <img
            src="/whatsapp-icon.svg"
            alt="Chat on WhatsApp"
            className="whatsapp-icon"
          />
        )}
      </a>
    </>
  );
};

export default WhatsAppButton;
